import { Calendar as AntCalendar, CalendarProps } from "antd";
import styled from "styled-components";

export const Calendar: typeof AntCalendar = styled(AntCalendar)<
  CalendarProps<any>
>``;
